<template>
  <el-row>
    <el-col :span="24">
      <div class="form-module-tit">{{ $locale('movie.infoAboutFile') }}</div>

      <el-form-item :label="$locale('movie.originalName')" prop="originalName">
        <el-input :placeholder="$locale('movie.plsEnterOriginalName')" v-model="formData.originalName" maxlength="255"></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.genre')" prop="genres">
        <!-- <el-select
          :placeholder="$locale('movie.plsEnterGenre')"
          value-key="id"
          v-model="formData.genres"
          multiple
          filterable
          allow-create
          :default-first-option="true"
        >
          <el-option
            v-for="item in genreOptions"
            :label="item.name"
            :value="item"
            :key="item.id"
          ></el-option>
        </el-select> -->
        <RemoteSelectV2
          ref="selectV2Client"
          type="genres"
          :list="comGenresList"
          v-model="formData.genres"
          :isMultiple="true"
          :formValue.sync="formData.genres"
          :fields="['id', 'name']"
          @setList="arr => comGenresList = arr"
          :allowCreate="true"
          :isObjectItem="true" />
      </el-form-item>
      <el-form-item :label="$locale('movie.countryOfManufacture')" prop="areas">
        <RemoteSelectV2
          ref="selectV2Client"
          type="areas"
          :list="comAreasList"
          v-model="formData.areas"
          :isMultiple="true"
          :formValue.sync="formData.areas"
          :fields="['id', 'name']"
          @setList="arr => comAreasList = arr"
          :allowCreate="true"
          :isObjectItem="true" />
        <!-- <el-select
          :placeholder="$locale('movie.plsEnterCountryOfManufacture')"
          value-key="id"
          multiple
          filterable
          allow-create
          v-model="formData.areas"
          :default-first-option="true"
        >
          <el-option
            v-for="item in countryOptions"
            :label="item.name"
            :value="item"
            :key="item.id"
          ></el-option>
        </el-select> -->
      </el-form-item>
      <el-form-item :label="$locale('movie.director')" prop="directors">
        <!-- <el-select
          :placeholder="$locale('movie.plsEnterDirector')"
          value-key="id"
          v-model="formData.directors"
          multiple
          filterable
          allow-create
          :default-first-option="true"
        >
          <el-option
            v-for="item in directorOptions"
            :label="item.name"
            :value="item"
            :key="item.id"
          ></el-option>
        </el-select> -->
        <RemoteSelectV2
          ref="selectV2Client"
          type="director"
          :list="comDirectorList"
          v-model="formData.directors"
          :isMultiple="true"
          :formValue.sync="formData.directors"
          :fields="['id', 'name', 'roles']"
          @setList="arr => comDirectorList = arr"
          :allowCreate="true"
          :isObjectItem="true"
        />
      </el-form-item>
      <el-form-item :label="$locale('movie.writers')" prop="writers">
        <!-- <el-select
          :placeholder="$locale('movie.plsEnterWriters')"
          value-key="id"
          v-model="formData.writers"
          multiple
          filterable
          allow-create
          :default-first-option="true"
        >
         <el-option
          v-for="item in writerOptions"
          :label="item.name"
          :value="item"
          :key="item.id"
          ></el-option>
        </el-select> -->
        <RemoteSelectV2
          ref="selectV2Client"
          type="writers"
          :list="comWriterList"
          v-model="formData.writers"
          :isMultiple="true"
          :formValue.sync="formData.writers"
          :fields="['id', 'name', 'roles']"
          @setList="arr => comWriterList = arr"
          :allowCreate="true"
          :isObjectItem="true"
        />
      </el-form-item>
      <el-form-item :label="$locale('movie.actor')" prop="actors">
        <!-- <el-select
          :placeholder="$locale('movie.plsEnterActor')"
          value-key="id"
          v-model="formData.actors"
          multiple
          filterable
          allow-create
          :default-first-option="true"
        >
          <el-option
            v-for="item in actorOptions"
            :label="item.name"
            :value="item"
            :key="item.id"
          ></el-option>
        </el-select> -->
        <RemoteSelectV2
          ref="selectV2Client"
          type="actor"
          :list="comActorList"
          v-model="formData.actors"
          :isMultiple="true"
          :formValue.sync="formData.actors"
          :fields="['id', 'name', 'roles']"
          @setList="arr => comActorList = arr"
          :allowCreate="true"
          :isObjectItem="true"
        />
      </el-form-item>
      <el-form-item :label="$locale('movie.credit')" prop="credit">
        <el-input
          :placeholder="$locale('movie.plsEnterCredit')"
          v-model="formData.credit"
          maxlength="255"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.productionYear')" prop="productionYear">
        <el-input
          :placeholder="$locale('movie.plsEnterProductionYear')"
          v-model="formData.productionYear"
          maxlength="255"
        ></el-input>
      </el-form-item>      
      <el-form-item :label="$locale('movie.filmSynopsis')" prop="intro">
        <el-input
          :placeholder="$locale('movie.plsEnterfilmSynopsis')"
          v-model="formData.intro"
          type="textarea"
          class="movie-intro"
          maxlength="1000"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.classify')" prop="category">
        <div class="elg-tag-group">
          <template :span="6" v-for="btn in category">
            <el-button
              :class="btn == formData.category ? 'egl-btn-white-gray-border act' : 'egl-btn-white-gray-border'"
              @click="classify_fn(btn)"
              :key="btn"
            >{{ btn }}</el-button>
          </template>
        </div>
      </el-form-item>
      <el-form-item :label="$locale('movie.copyright')" prop="copyRight">
        <el-input
          :placeholder="$locale('movie.plsEnterCopyright')"
          v-model="formData.copyRight"
          maxlength="255"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.distribution')" prop="distributor">
        <!-- <el-select
          :placeholder="$locale('movie.plsEnterDistribution')"
          v-model="formData.distributor"
          :filterable="true"
        >
          <el-option
            v-for="item in distributorOptions"
            :label="item.name"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select> -->
        <!-- <template v-if="$route.path.indexOf('create') > -1 || formData.id">
          <remote-select
            type="client"
            :isMultiple="false"
            v-model="formData.distributor"
            :formValue.sync="formData.distributor"
            :actionType="$route.path.indexOf('create') > -1 ? 'create' : 'edit'"
          ></remote-select>
        </template> -->
        <RemoteSelectV2
          ref="selectV2Client"
          type="client"
          :list="comClientList"
          v-model="formData.distributor"
          :isMultiple="false"
          :formValue.sync="formData.distributor"
          :fields="['id', 'name']"
          @setList="arr => comClientList = arr"
          :allowCreate="true"
        />
      </el-form-item>
      <el-form-item :label="$locale('movie.officialWebsite')" prop="website">
        <el-input
          :placeholder="$locale('movie.plsEnterOfficialWebsite')"
          v-model="formData.website"
          maxlength="255"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.synopsisTitle')" prop="synopsisTitle">
        <el-input
          :placeholder="$locale('movie.synopsisTitlePlsInput')"
          v-model="formData.synopsisTitle"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.synopsis')" prop="synopsis">
        <editor v-model="formData.synopsis" />
      </el-form-item>
      <el-form-item :label="$locale('movie.profileTitle')" prop="profileTitle">
        <el-input
          :placeholder="$locale('movie.profileTitlePlsInput')"
          v-model="formData.profileTitle"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$locale('movie.profile')" prop="profile">
        <editor v-model="formData.profile" />
      </el-form-item>
      <hr class="dotted" />
    </el-col>
  </el-row>
</template>

<script>
import { categoryBtns } from "@/assets/js/movieStatic";
import Editor from "@/components/common/Tinymce/Rich";
import RemoteSelectV2 from "@/components/common/RemoteSelect-v2";

export default {
  name: "more-info",
  componentName: "moreInfo",
  props: {
    formData: {
      required: true,
      type: Object,
    },
    formRef: {
      type: Object,
      default: () => {}
    },
    genreOptions: {
      required: true,
      type: Array,
    },
    countryOptions: {
      required: true,
      type: Array,
    },
    directorOptions: {
      required: true,
      type: Array,
    },
    distributorOptions: {
      required: true,
      type: Array,
    },
    actorOptions: {
      required: true,
      type: Array,
    },
    writerOptions: {
      required: true,
      type: Array,
    },
    category: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      categoryBtns,
      comClientList: [],
      comActorList: [],
      comDirectorList: [],
      comWriterList: [],
      comGenresList: [],
      comAreasList: [],
    };
  },
  methods: {
    classify_fn(val) {
      this.formData.category = val;
      this.formRef.clearValidate("category");
    },
  },
  watch: {
    distributorOptions(val) {
      this.comClientList = val;
    },
    actorOptions(val) {
      this.comActorList = val;
    },
    directorOptions(val) {
      this.comDirectorList = val;
    },
    writerOptions(val) {
      this.comWriterList = val;
    },
    genreOptions(val) {
      this.comGenresList = val;
    },
    countryOptions(val) {
      this.comAreasList = val;
    }
  },
  components: {
    Editor,
    RemoteSelectV2
  }
};
</script>